import { render } from "./areaChart1.vue?vue&type=template&id=62c78b24"
import script from "./areaChart1.vue?vue&type=script&lang=js"
export * from "./areaChart1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__